import { AUTHENTICATION_V2_PROXY_ROUTE } from '@dtx-company/true-common/src/constants/endpoints'
import {
  FRONTEGG_AUTH_JSON_HEADERS,
  FRONTEGG_UPDATE_USER_ENDPOINT,
  JSON_HEADERS
} from './constants'
import { logger } from '@dtx-company/logger'

export async function addUserToCohort(token: string, cohort: string): Promise<void> {
  try {
    const updateRes = await fetch(FRONTEGG_UPDATE_USER_ENDPOINT, {
      method: 'PUT',
      body: JSON.stringify({
        metadata: JSON.stringify({ cohort })
      }),
      headers: {
        ...FRONTEGG_AUTH_JSON_HEADERS,
        Authorization: `Bearer ${token}`
      }
    })
    if (!updateRes.ok) {
      await logger.logFetchError(updateRes, { technicalArea: 'authentication' })
    }
    const cohortRes = await fetch(AUTHENTICATION_V2_PROXY_ROUTE + '/v2/cohorts', {
      method: 'POST',
      body: JSON.stringify({
        cohortName: cohort
      }),
      headers: {
        ...JSON_HEADERS,
        Authorization: `Bearer ${token}`
      }
    })
    if (!cohortRes.ok) {
      await logger.logFetchError(cohortRes, { technicalArea: 'authentication' })
    }
  } catch (e: unknown) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
